import { useCallback } from 'react';

import { DropdownListItem } from 'webclient.constants';
import { RadioInputDecor } from 'lib/form/radio-input/radio-input-new.style';
import { Dropdown } from './dropdown';
import { DropdownSelectItem } from './dropdown-item.style';
import { MarginProps } from 'approot/shared/styles/spacing.style';

type Props = {
  options: DropdownListItem[];
  'data-selector'?: string;
  handleChange?: (value: string) => void;
  selectedDropdownOptions?: string[];
  placeholder?: string;
  isLoading?: boolean;
  isInline?: boolean;
  menuMatchToggleWidth?: boolean;
} & MarginProps;

const DropdownSingleSelect = ({
  options,
  selectedDropdownOptions,
  handleChange,
  placeholder,
  isLoading,
  isInline,
  menuMatchToggleWidth = true,
  ...rest
}: Props) => {
  let displayText = placeholder || 'All';
  if (selectedDropdownOptions && selectedDropdownOptions.length > 0) {
    displayText =
      options.find(opt => opt.value === selectedDropdownOptions[0])?.label ||
      placeholder ||
      'All';
  }

  const handleSelect = useCallback(
    (value: string) => {
      handleChange && handleChange(value);
    },
    [handleChange]
  );

  return (
    <Dropdown
      menuMatchToggleWidth={menuMatchToggleWidth}
      buttonElement={displayText}
      isLoading={isLoading}
      isInline={isInline}
      dropdownContents={
        <>
          {options.map((option, index) => (
            <DropdownSelectItem
              role="radio"
              aria-checked={!!selectedDropdownOptions?.includes(option.value)}
              $checked={!!selectedDropdownOptions?.includes(option.value)}
              key={`option-${index}`}
              data-selector={`${rest['data-selector']}-option`}
              onClick={() => handleSelect(option.value)}
            >
              <RadioInputDecor>
                <div />
              </RadioInputDecor>
              <span>{option.label}</span>
            </DropdownSelectItem>
          ))}
        </>
      }
      {...rest}
    />
  );
};

export default DropdownSingleSelect;
